<template>
  <div class="userManage">
    <div v-if="UserId">
      <information :userData="userData"></information>
      <enterprise :userData="userData"></enterprise>
    </div>
    <div v-if="CustomerId">
      <customerInfo :userData="userData"></customerInfo>
    </div>
    <div class="userBox" @click="gotoPrivacy">
      <div class="col1">
        <span class="label">{{ $t.meta.privacy }}</span>
      </div>
      <div class="col2">
        <van-image class="iconImg" :src="arrow"></van-image>
      </div>
    </div>
    <div class="userBox" @click="goKefuList">
      <div class="col1">
        <span class="label">{{ $t.meta.kefuList }}</span>
      </div>
      <div class="col2">
        <van-image class="iconImg" :src="arrow"></van-image>
      </div>
    </div>
    <div class="userBox" @click="goAcountDelete" v-if="UserId">
      <div class="col1">
        <span class="label">{{ $t.meta.accountDelete }}</span>
      </div>
      <div class="col2">
        <van-image class="iconImg" :src="arrow"></van-image>
      </div>
    </div>
    <div class="userBox" @click="goAboutUs">
      <div class="col1">
        <span class="label">{{ $t.meta.aboutUs }}</span>
      </div>
      <div class="col2">
        <van-image class="iconImg" :src="arrow"></van-image>
      </div>
    </div>
    <user-settings></user-settings>
  </div>
</template>
<script>
import Information from "./components/Information";
import Enterprise from "./components/Enterprise";
import CustomerInfo from "./components/CustomerInfo";
import UserSettings from "./components/UserSettings";
import { mapGetters, mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";
import { isAPP, getPlatform } from "@/plugins/environment/type.js";

export default {
  name: "UserManage",
  components: {
    Information,
    Enterprise,
    CustomerInfo,
    UserSettings,
  },
  computed: {
    ...mapGetters(["isLogging"]),
  },
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      userData: {},
      arrow: require("@/assets/img/userManage/icon_setting_right@2x.png"),
    };
  },
  mounted() {
    //极光推送
    if (this.UserId) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.setAlias, {
        alias: this.UserId,
      });
      if (this.isLogging) this.getUserInfo();
    }
    if (this.CustomerId) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.setAlias, {
        alias: this.CustomerId,
      });
      if (this.isLogging) this.loadCustomerHomeInfo();
    }
  },
  methods: {
    gotoPrivacy() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "privacy",
        name: "privacy",
        query: [],
      });
    },
    goAboutUs() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "aboutUs",
        name: "aboutUs",
        query: [],
      });
    },
    goAcountDelete() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "accountDeletion",
        name: "AccountDeletion",
        query: [],
      });
    },
    goKefuList() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "kefuList",
        name: "KefuList",
        query: [],
      });
    },
    getUserInfo() {
      this.$commonMethod.showLoading();
      var param = {
        UserId: this.UserId,
      };
      this.$api.myHome
        .getUserInfo(param)
        .then((res) => {
          this.userData = res.data;
          this.SET_AUTH(res.data);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    loadCustomerHomeInfo() {
      this.$commonMethod.showLoading();
      var param = {
        CustomerId: this.CustomerId,
      };
      this.$api.customerManagement
        .loadCustomerHomeInfo(param)
        .then((res) => {
          this.userData = res.data;
          this.SET_AUTH(res.data);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    ...mapMutations([SET_AUTH]),
  },
};
</script>
<style lang="scss" scoped>
.userManage {

  .userBox {
    padding: 3% 0;
    border-bottom: 1px solid #ebedf0;

    .col1 {
      vertical-align: middle;
      display: inline-block;
      width: 85%;
      font-size: 14px;
      margin-left: 5%;
    }

    .col2 {
      text-align: left;
      vertical-align: top;
      display: inline-block;
      width: 10%;

      .iconImg {
        width: 20px;
        height: 20px;
        object-fit: contain;
        margin-right: 5px;
        vertical-align: middle;
      }
    }
  }
}
</style>
